import React, { useState } from 'react';
import '../SidePos/Side.css';
import Modal from 'react-modal';
import { FaPercent, FaCar, FaArrowAltCircleDown } from "react-icons/fa";
import { FaLocationDot, FaCarOn } from "react-icons/fa6";
import { MdSupportAgent } from "react-icons/md";
import { GiReceiveMoney } from "react-icons/gi";

const Side = () => {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: ''
  });

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic
    console.log('Form submitted:', formData);
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <div className="site-visit-section">
      <h2>Organize Site Visit</h2>
      <div className="butt-div">
        <button className="button-13" onClick={openModal}>Call Back</button>
      </div>
      <form onSubmit={handleSubmit} className="site-visit-form">
        <h3>Pre-Register here for Best Offers</h3>
        <label>
          Name:
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Mobile No:
          <input
            type="tel"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          E-Mail Address:
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </label>
        <div className="butt-div">
          <button className="button-14" type="submit">Pre-Register Now</button>
        </div>
      </form>
      <h2 className="booksv">Book a Site Visit</h2>
      <div className="property-details">
        <p>✓ Price: ₹ 11,500/- Sq.Ft.*</p>
        <p>✓ Typology: 3 & 4 BHK</p>
        <p>✓ Location: Sector 12, Noida Extension</p>
      </div>
      <div className="logo-side">
        <div className="logo-main">
          <FaPercent className="logo-po" />
        </div>
        <div className="logo-main">
          <FaCar className="logo-po" />
        </div>
        <div className="logo-main">
          <FaLocationDot className="logo-po" />
        </div>
        <div className="logo-main">
          <FaArrowAltCircleDown className="logo-po" />
        </div>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Call Back Modal"
        className="modal-main2"
      >
        <button className="close-button2" onClick={closeModal}>×</button>
        <div className="modal-full">
          <div className="modalleft">
            <h4 className="modal-heading">We Promise</h4>
            <div className="modal-logo-left">
              <MdSupportAgent className="modal-logo1" />
              <p className="modal-sub-heading">Instant Call Back</p>
            </div>
            <div className="modal-logo-left">
              <FaCarOn className="modal-logo1" />
              <p className="modal-sub-heading">Free Site Visit</p>
            </div>
            <div className="modal-logo-left">
              <GiReceiveMoney className="modal-logo1" />
              <p className="modal-sub-heading">Unmatched Price</p>
            </div>
          </div>
          <div className="modalright">
            <h2 className="modal-heading">Ace Residential</h2>
            <p className="modal-sub-heading">At Sector 12, Noida Extension</p>
            <form className="modal-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="mobile">Mobile:</label>
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="butt-f">
                <button className="submit-button-f" type="submit">Enquire Now</button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Side;
